import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/Audiences.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/audiences`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, { trackingId: e }));
	}
};
export { n as Audiences };

//# sourceMappingURL=Audiences.js.map